export default function getRoutesFromNames(routeNames, routes) {
  const routeMap = {};

  function buildMap(routeList) {
    for (const route of routeList) {
      if (route.name) {
        routeMap[route.name] = {
          href: route.href,
          label: route.label,
          icon: route.icon,
        };
      }
      if (route.routes) {
        buildMap(route.routes);
      }
    }
  }

  buildMap(routes);

  const menuRoutes = routeNames
    .map((item) => {
      const names = Array.isArray(item) ? item : [item];
      const primaryName = names[0];
      const extraNames = names.slice(1);

      const primaryRoute = routeMap[primaryName];
      if (!primaryRoute) {
        console.warn(`Ruta con name "${primaryName}" no encontrada`);
        return null;
      }

      const activePaths = [primaryRoute.href];
      for (const name of extraNames) {
        const route = routeMap[name];
        if (route && route.href) {
          activePaths.push(route.href);
        } else {
          console.warn(`Ruta con name "${name}" no encontrada`);
        }
      }

      return {
        href: primaryRoute.href,
        label: primaryRoute.label,
        icon: primaryRoute.icon ?? "help",
        activePaths,
        name: primaryName,
      };
    })
    .filter(Boolean);

  return menuRoutes;
}
